import { Button } from "antd";
import IntlMessages from "components/Message/IntlMessages";
import { replace } from "connected-react-router";
import { Routes } from "const";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { redirectToPrimaryProduct } from "redux/reducers/disclaimer";
import { CustomerSelector } from "redux/selector/customer-selector";
import styled from "styled-components";

function RestrictionPage() {
  const dispatch = useDispatch();
  const isPwmUser = useSelector(CustomerSelector.isPwmUser);

  function backToLandingPage() {
    if (isPwmUser) {
      dispatch(replace(Routes.UltraHigh.Portfolio.Home));
    } else {
      dispatch(redirectToPrimaryProduct({ replaceUrl: true }));
    }
  }

  return (
    <PwmRestrictionPageStyled>
      <h2>
        <IntlMessages id="global.permission.denied" />
      </h2>
      <Button onClick={backToLandingPage}>
        <IntlMessages id="global.goback.to.main" />
      </Button>
    </PwmRestrictionPageStyled>
  );
}

export default RestrictionPage;

const PwmRestrictionPageStyled = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;
